import type { PrivilegeDefinition } from '@/core/be/security/SecurityTypes';
import type { FeatureModule } from '@/core/platform/features/FeatureModule';
import { SearchEnvConfig } from './core/SearchEnvConfig';

export const SearchPrivilegeIds = {
  basic: 'search:basic',
  advanced: 'search:advanced',
} as const;

const SearchPrivileges: PrivilegeDefinition[] = [
  {
    id: SearchPrivilegeIds.basic,
    scope: 'vault', // Vault-scoped so roles can grant it
    feature: 'search',
    description: 'Use basic BM25 full-text search.',
    subscriptionGated: true,
    subscriptionFeatureId: 'search:basic',
    label: 'Basic Search',
  },
  {
    id: SearchPrivilegeIds.advanced,
    scope: 'vault', // Vault-scoped so roles can grant it
    feature: 'search',
    description: 'Use AI or semantic filters while searching.',
    subscriptionGated: true,
    subscriptionFeatureId: 'search:semantic',
    label: 'Semantic Search',
    tierRequired: 'pro',
  },
];

export class SearchFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'search',
    envSchema: SearchEnvConfig.getSchema(),
    privileges: SearchPrivileges,
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return SearchFeatureModule.definition;
  }
}
